/* eslint-disable import/prefer-default-export */
export const getProcategories = state => state.procategories
export const getBackupProcategories = state => state.backupProcategories
